// extracted by mini-css-extract-plugin
export default {"headers":"oEOE_NHpnppEYRe0XcoW","placeHolderShimmer":"CEUmB60O2qtk42XxzCdQ"};